import { useCallback } from "react";
import { useParams } from "react-router-dom";
import AdminDashboard from "./AdminDashboard";
import "./AdminPortalToday.css";
import "./athleticWorkspace.css";
import { legacyToAdminPortalPath } from "../utils/adminPortalRollout";

// All task links stay in the organization workspace, including unknown routes.
export const todayPortalPath = (path, orgSlug, workspaceOrgId) => {
  const url = new URL(path, "https://app.sporthouse.ai");
  return `${legacyToAdminPortalPath(url.pathname, orgSlug, url.search, workspaceOrgId)}${url.hash}`;
};

export default function AdminPortalToday({ organization }) {
  const { orgSlug, workspaceOrgId } = useParams();
  const mapPath = useCallback((path) => todayPortalPath(path, orgSlug, workspaceOrgId), [orgSlug, workspaceOrgId]);
  return <div data-testid="admin-portal-today"><AdminDashboard key={organization?.org_id || orgSlug} embedded organization={organization} mapPath={mapPath} /></div>;
}
